export const carouselImages = [
    {
        "imagen" : "../assets/imgs/1.jpg"
    },
    {
        "imagen" : "../assets/imgs/2.jpg"
    },
    {
        "imagen" : "../assets/imgs/3.jpg"
    },
    {
        "imagen" : "../assets/imgs/4.jpg"
    },
]